import { render, staticRenderFns } from "./DeleteMediaModal.vue?vue&type=template&id=4c398332&"
import script from "./DeleteMediaModal.vue?vue&type=script&lang=js&"
export * from "./DeleteMediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports